
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17 2.534c1.399 0 2.797.533 3.865 1.601s1.6 2.466 1.6 3.865H24a6.983 6.983 0 00-2.05-4.95A6.979 6.979 0 0017 1v1.534zm0 1.29c1.069 0 2.138.407 2.953 1.223S21.176 6.931 21.176 8h-1.62a2.55 2.55 0 00-.749-1.808 2.55 2.55 0 00-1.808-.749V3.824zm.708 4.883a1 1 0 11-1.414-1.416 1 1 0 011.414 1.416zM22 10v9H0V3h15v2H2v12h18v-7h2zm-6 11c-1 1.194-2.862 2-5 2s-4-.806-5-2h10z"}})])
          )
        }
      }
    